import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { first, map, mergeMap } from 'rxjs/operators';

import {
  InitialiseWithTenantAction,
  TenantActionTypes,
} from './tenant.actions';
import { TenantService } from './tenant.service';

@Injectable()
export class TenantEffects {
  constructor(
    private actions$: Actions,
    private tenantService: TenantService,
  ) {}

  loadTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActionTypes.LOAD),
      first(),
      mergeMap(_action =>
        this.tenantService
          .getTenant()
          .pipe(map(tenant => new InitialiseWithTenantAction(tenant))),
      ),
    ),
  );
}
